const contactInfo = [
  {
    icon: "ri-building-line",
    title: "Văn phòng công ty",
    lines: [
      "Thửa đất số 1235, tờ bản đồ số 06",
      "Tổ 16, Phường An Khê, TP. Đà Nẵng",
    ],
  },
  {
    icon: "ri-flask-2-line",
    title: "Phòng thí nghiệm",
    lines: [
      "Số 26 đường Phan Anh",
      "Phường Cẩm Lệ, TP. Đà Nẵng",
    ],
  },
  {
    icon: "ri-phone-line",
    title: "Điện thoại",
    lines: ["0236.6517174", "0914.410174"],
  },
  {
    icon: "ri-mail-line",
    title: "Email",
    lines: ["thuanphatkt.company@gmail.com"],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 text-[#0E5C3A] text-sm font-semibold uppercase tracking-widest mb-3">
            <i className="ri-map-pin-line"></i>
            Liên hệ
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mt-2">
            THÔNG TIN <span className="text-[#0E5C3A]">LIÊN HỆ</span>
          </h2>
          <div className="w-16 h-1 bg-[#D4A017] mx-auto mt-4 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          {/* Contact info */}
          <div className="lg:col-span-2 space-y-4">
            {contactInfo.map((info) => (
              <div key={info.title} className="flex items-start gap-3 p-4 bg-[#F5F7F2] rounded-xl">
                <div className="w-10 h-10 flex items-center justify-center bg-[#0E5C3A] text-white rounded-lg shrink-0">
                  <i className={`${info.icon} text-base`}></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-800 text-sm mb-0.5">{info.title}</div>
                  {info.lines.map((line) => (
                    <div key={line} className="text-gray-600 text-sm">{line}</div>
                  ))}
                </div>
              </div>
            ))}

            {/* Quick actions */}
            <div className="flex gap-3 pt-1">
              <a
                href="tel:02366517174"
                className="flex-1 flex items-center justify-center gap-2 bg-[#0E5C3A] text-white py-2.5 rounded-lg text-sm font-semibold hover:bg-[#0A4A2E] transition-colors cursor-pointer"
              >
                <i className="ri-phone-fill"></i>
                Gọi ngay
              </a>
              <a
                href="mailto:thuanphatkt.company@gmail.com"
                className="flex-1 flex items-center justify-center gap-2 border-2 border-[#0E5C3A] text-[#0E5C3A] py-2.5 rounded-lg text-sm font-semibold hover:bg-[#0E5C3A] hover:text-white transition-colors cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                Gửi email
              </a>
            </div>
          </div>

          {/* Map */}
          <div className="lg:col-span-3 rounded-xl overflow-hidden h-[320px] md:h-[400px] border border-gray-100">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3834.5!2d108.21!3d16.04!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3142190c1f98d44d%3A0x9e7e89b38f7e5fa4!2zMjYgUGhhbiBBbmgsIEPhuqltIEzhu4csIMSQw6AgTuG6tW5nLCBWaWV0bmFt!5e0!3m2!1sen!2s!4v1700000000000!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Vị trí Phòng thí nghiệm Thuận Phát"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
